import {
  Activity,
  BarChart3,
  Boxes,
  Building2,
  CreditCard,
  FileText,
  Home,
  Layers,
  Package,
  Receipt,
  Settings,
  ShoppingBag,
  Tags,
  TrendingUp,
  Truck,
  Users,
  UsersRound,
  Warehouse,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { Role } from '@/types/api';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Roles that can see this nav entry. Owner is always allowed. */
  allow: Role[];
  /** Optional group heading the item belongs under. */
  group?: string;
}

/**
 * The nav lives here so the side panel + the search palette + breadcrumbs
 * stay in sync. Roles:
 *   - owner: everything
 *   - manager: ops + reports, no employees, no settings creates
 *   - accountant (CA): bills + reports + GST exports, read-only feel
 */
export const NAV: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: Home, allow: ['owner', 'manager', 'accountant'] },

  { group: 'Sales', to: '/bills', label: 'Bills', icon: Receipt, allow: ['owner', 'manager', 'accountant'] },
  { group: 'Sales', to: '/customers', label: 'Customers', icon: Users, allow: ['owner', 'manager'] },

  { group: 'Inventory', to: '/products', label: 'Products', icon: Package, allow: ['owner', 'manager'] },
  { group: 'Inventory', to: '/stock', label: 'Stock', icon: Boxes, allow: ['owner', 'manager'] },
  { group: 'Inventory', to: '/categories', label: 'Categories', icon: Layers, allow: ['owner', 'manager'] },
  { group: 'Inventory', to: '/brands', label: 'Brands', icon: Tags, allow: ['owner', 'manager'] },
  { group: 'Inventory', to: '/suppliers', label: 'Suppliers', icon: Truck, allow: ['owner', 'manager'] },

  { group: 'Money', to: '/expenses', label: 'Expenses', icon: ShoppingBag, allow: ['owner', 'manager', 'accountant'] },
  { group: 'Money', to: '/reports', label: 'Reports', icon: BarChart3, allow: ['owner', 'manager', 'accountant'] },
  { group: 'Money', to: '/reports/analytics', label: 'Deep analytics', icon: Activity, allow: ['owner', 'accountant'] },
  { group: 'Money', to: '/reports/revenue', label: 'Revenue analytics', icon: TrendingUp, allow: ['owner', 'manager', 'accountant'] },
  { group: 'Money', to: '/reports/gst', label: 'GST', icon: FileText, allow: ['owner', 'accountant'] },

  { group: 'Shop', to: '/branches', label: 'Branches', icon: Warehouse, allow: ['owner'] },
  { group: 'Shop', to: '/employees', label: 'Employees', icon: UsersRound, allow: ['owner'] },

  { group: 'Account', to: '/subscription', label: 'Subscription', icon: CreditCard, allow: ['owner'] },
  { group: 'Account', to: '/settings', label: 'Settings', icon: Settings, allow: ['owner'] },
  { group: 'Account', to: '/settings/profile', label: 'Business profile', icon: Building2, allow: ['owner'] },
];

export function navForRoles(roles: Role[]): NavItem[] {
  // Owner sees everything regardless.
  if (roles.includes('owner')) return NAV;
  return NAV.filter((item) => item.allow.some((r) => roles.includes(r)));
}
